<script>
	// The params prop contains values matched from the URL
	export let params = {}

	import {push, replace} from 'svelte-spa-router';
	import {afterUpdate, createEventDispatcher, onMount} from 'svelte';
	import TBoxInterno from '../templates/TBoxInterno.svelte';
	import BarraOperacoesRegistro from '../../componentes/BarraOperacoesRegistro.svelte';
	import {sTituloPaginaAtual} from '../../stores';
	import {
		API,
		ativarLinksEmTexto,
		cabecalhoPadraoRequisicao,
		dadosUsuarioLS, removerObjeto,
		rolarPagina,
		StatusHttp,
		TextoFeedback,
		TipoEvento,
		TipoPerfil
	} from '../../utils';

	const dispatch = createEventDispatcher();
	let projeto = {};
	let dadosUsuario;
	let opcoesOperacoes = [];
	let opcoesOperacoesTopo = [];
	let opcoesOperacoesRodape = [];
	let participantes = [];
	let avaliacoes = [];
	let relatorios = [];
	let apresentacoes = [];
	let lista_resumo_relatorios = [];
	let distribuicoes = [];
	let anexos = [];
	let perfilUsuarioToken = "";

	//  curso ead / AGENDA 2030
	let cursoEAD, conheceAgenda2030;
	let listaODSCadastrada = [];

	// usado para exibir alerta pro usuário coordenador que o projeto precisa ser atualizado e preencher todas as informações
	let alertaCadastroIncompleto = false;

	// para controle de expandir/contrair conteudo do projeto
	let conteudoProjetoExpandido = false;
	let divConteudoProjeto;

	onMount(async () => {
		$sTituloPaginaAtual = `Visualização de Projeto (cód.: ${params.codigo})`;
		
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando projeto ...',
		});
		
		dadosUsuario = dadosUsuarioLS();
		perfilUsuarioToken = dadosUsuario.perfil;

		const resposta = await fetch(API(`projetos/${params.codigo}`), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			console.log(erros);
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("#/painel");
		});
		
		const { dados, status } = await resposta.json();
		
		if (status == StatusHttp.OK) {
			projeto = dados;
			participantes = projeto.participantes;
			avaliacoes = projeto.avaliacoes;
			distribuicoes = projeto.distribuicoes;
			anexos = projeto.anexos;
			relatorios = projeto.relatorios;
			apresentacoes = projeto.apresentacoes;
			lista_resumo_relatorios = projeto.lista_resumo_relatorios ?? [];

			listaODSCadastrada = projeto?.lista_ods_possui_relacao ?? [];

			if (projeto?.preve_inclusao_alunos_ead === 1)
				cursoEAD = 'SIM';
			else if (projeto?.preve_inclusao_alunos_ead === 0)
				cursoEAD = 'NÃO';
			else {
				cursoEAD = 'Informação não cadastrada';
				alertaCadastroIncompleto = true;
			}

			if (projeto?.conhece_agenda2030 === 1)
				conheceAgenda2030 = 'SIM';
			else if (projeto?.conhece_agenda2030 === 0)
				conheceAgenda2030 = 'NÃO';
			else {
				conheceAgenda2030 = 'Informação não cadastrada';
				alertaCadastroIncompleto = true;
			}

			opcoesOperacoes = [{
				titulo: 'Painel',
				callback: () => push('#/painel')
			}];

			switch (perfilUsuarioToken) {
				case TipoPerfil.COORDENADOR:
					opcoesOperacoes.push(
						{
							titulo: '+ Anexos',
							cor: 'is-success',
							callback: () => push(`#/projeto/anexos/adicionar/${projeto.codigo}`)
						},
						{
							titulo: '+ Relatório',
							cor: 'is-success',
							callback: () => push(`#/projeto/relatorios/cadastro/${projeto.codigo}/${projeto.id}/${projeto.modalidade_const}?tp=${window.btoa(unescape(encodeURIComponent(projeto.titulo)))}`)
						},
						{
							titulo: 'Alterar',
							cor: 'is-link',
							callback: () => push(`#/projeto/atualizacao/${projeto.codigo}`)
						}, 
						// {
						// 	titulo: 'Solicitar Renovação',
						// 	cor: 'is-info is-light',
						// 	callback: () => push(`#/projeto/solicitacoes/renovacao/${projeto.codigo}`)
						// },
					);

					if (projeto.apresentacoes?.length > 0) {
						opcoesOperacoes.push({
							titulo: 'Apresentações',
							cor: 'is-info',
							callback: () => exibirApresentacoes()
						});
					}
				break;

				case TipoPerfil.DISCENTE:
					opcoesOperacoes.push(
						{
							titulo: 'Adicionar Relatório',
							cor: 'is-success',
							callback: () => push(`#/projeto/relatorios/cadastro/${projeto.codigo}/${projeto.id}/${projeto.modalidade_const}?tp=${window.btoa(unescape(encodeURIComponent(projeto.titulo)))}`)
						},
					);

					if (projeto.apresentacoes?.length > 0) {
						opcoesOperacoes.push({
							titulo: 'Apresentações',
							cor: 'is-info',
							callback: () => exibirApresentacoes()
						});
					}
				break;

				case TipoPerfil.CETREINA:
					opcoesOperacoes.push(
						{
							titulo: 'Remover',
							cor: 'is-danger',
							callback: () => removerProjeto(projeto.id)
						}
					);

					if (projeto.apresentacoes?.length > 0) {
						opcoesOperacoes.push({
							titulo: 'Apresentações',
							cor: 'is-info',
							callback: () => exibirApresentacoes()
						});
					}
				break
			}
		} else {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			replace('#/projeto-inexistente');
			return;
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		opcoesOperacoesTopo = [ ... opcoesOperacoes];
		opcoesOperacoesRodape = [ ... opcoesOperacoes];

		opcoesOperacoesTopo.push({
			titulo: 'Rolar para baixo',
			cor: 'is-black is-outlined',
			callback: () => rolarPagina(document.body.scrollHeight)
		}, {
			titulo: 'Imprimir',
			cor: 'is-black is-outlined',
			callback: () => window.open(`#/projeto/imprimir/${projeto.codigo}`, '_blank')
		});

		opcoesOperacoesRodape.push({
			titulo: 'Rolar para cima',
			cor: 'is-black is-outlined',
			callback: () => rolarPagina(0)
		});
	});

	afterUpdate(() => {
		divConteudoProjeto = document.querySelector('.conteudoProjeto');

		if (divConteudoProjeto != null)
			divConteudoProjeto.style.maxHeight = conteudoProjetoExpandido ? `${divConteudoProjeto.scrollHeight}px` : '500px';
	});

	const alternarExpansao = () => conteudoProjetoExpandido = !conteudoProjetoExpandido;

	const exibirRelatorioProjeto = (objetoRelatorio) => {
		let conteudoModal = "";

		conteudoModal += objetoRelatorio.conteudo;
		
		conteudoModal += `<hr><p class="mt-2 mb-2 has-text-info">Outras Informações:</p>`;
		conteudoModal += `<p>Autoria: ${objetoRelatorio.autoria}</p>`;
		
		if (objetoRelatorio.anexos.length > 0) {
			conteudoModal += `<hr><p>Anexos: </p>`;

			objetoRelatorio.anexos.forEach(anexo => {
				conteudoModal += `<small>Tipo: ${anexo.tipo} | Valor: ${anexo.valor} | Data: ${anexo.adicionado_em}<br></small>`;
			});
		}

		dispatch('routeEvent', {
			tipo: TipoEvento.ABRIR_MODAL,
			titulo: objetoRelatorio.tipo,
			larguraMaxima: true,
			conteudo: conteudoModal
		});
	}

	const exibirAnexoProjeto = (objetoAnexo) => {
		let conteudoModal = "";
		
		conteudoModal += ativarLinksEmTexto(objetoAnexo.valor);
		conteudoModal += `<hr><p class="mt-2 mb-2 has-text-info">Outras Informações:</p>`;
		conteudoModal += `<p>Adicionado em: ${objetoAnexo.adicionado_em}</p>`;
		
		dispatch('routeEvent', {
			tipo: TipoEvento.ABRIR_MODAL,
			titulo: objetoAnexo.tipo,
			larguraMaxima: objetoAnexo.valor.trim().length > 64 ? true : false,
			conteudo: conteudoModal,
		});
	}

	const exibirApresentacoes = () => {
		let conteudoModal = "";

		apresentacoes.forEach( apresentacao => {
			conteudoModal += `
				<div class="columns">
					<div class="column">
						<p>Inscrição: <strong>${apresentacao.id_zerofill}/${apresentacao.ano}</strong></p>
						<p>Data cadastro: ${apresentacao.data_criacao}</p>
					</div>
				</div>
				<div class="columns">
					<div class="column">
						<a href="#/apresentacao/visualizar/${apresentacao.id}/${projeto.codigo}" class="button is-primary is-fullwidth">VER APRESENTAÇÃO</a>
					</div>
				</div>
				<hr>
			`;
		});
						
		dispatch('routeEvent', {
			tipo: TipoEvento.ABRIR_MODAL,
			titulo: "Apresentações",
			conteudo: conteudoModal
		});
	}

	const removerProjeto = async (idProjeto) => removerObjeto(idProjeto, dispatch, push, '#/painel/projetos', 'projetos', 'Deseja realmente remover o projeto? Todos os usuários vinculados, independente do papel no mesmo, perderão acesso ao projeto. \n\nO projeto só poderá ser recupera por solicitação via e-mail, com justificativa.');
	const removerAnexo = async (idAnexo) => removerObjeto(idAnexo, dispatch, push, '#/painel/projetos', 'projetos/anexos');

</script>

<style>
	.conteudoProjeto {
		min-height: 500px;
		overflow: hidden;
		transition: max-height 1s ease-in-out;
	}
</style>

<TBoxInterno
	titulo={projeto.titulo} 
	subtitulo="{projeto.alocacao} &bull; {projeto.modalidade} &bull; {projeto.unidade}"
	largura="12" 
	deslocamento="0">

	{#if alertaCadastroIncompleto && perfilUsuarioToken === TipoPerfil.COORDENADOR}
	<div class="notification is-danger is-light">
		O cadastro do projeto está incompleto! Favor clicar em <strong>'Alterar'</strong> e preencher os dados ausentes.
	</div>
	{/if}

	<br>

	<BarraOperacoesRegistro opcoes={ opcoesOperacoesTopo } />

	<div class="columns">
		<div class="column has-text-centered">
			<small>Os relatórios adicionados ficam no rodapé do projeto. Clique em <strong>"Rolar para baixo"</strong> para ver.</small>
		</div>
	</div>

	<hr>
	
	<span class="tag is-black is-pulled-right" title="Código do Projeto">Cód.: { projeto.codigo }</span>
	<span class="tag is-info is-pulled-right mr-1" title="Total de bolsas solicitadas">TB: { projeto.total_bolsas }</span>

	<p class="is-size-4 mb-4">Descrição</p>
	<div class="content">
		<div class="conteudoProjeto">
			{@html projeto.descricao}
		</div>

		{#if conteudoProjetoExpandido}
			<button on:click={alternarExpansao} class="button is-light is-rounded is-fullwidth">RECOLHER</button>
		{:else}
			<button on:click={alternarExpansao} class="button is-dark is-rounded is-fullwidth">EXIBIR TODO O CONTEÚDO</button>
		{/if}
	</div>

	<p class="has-text-centered">
		<span class="tag" title="Data de criação do projeto (adicionado no sistema)">Data cadastro: {projeto.data_criacao}</span> &bull; 
		<span class="tag" title="Data da última atualização do projeto">Última atualização: {projeto.data_ultima_atualizacao}</span>
	</p>

	<br>

	<hr>

	<p class="is-size-4 mb-4">Outras informações</p>

	<p>Prevê a inclusão de estudantes dos cursos de graduação EAD: <strong>{cursoEAD}</strong></p>
	<p>Conhece a Agenda 2030 da ONU:  <strong>{conheceAgenda2030}</strong></p>

	<br>

	<p>Objetivos de Desenvolvimento Sustentável (AGENDA 2030 da ONU - <small><a href="https://brasil.un.org/pt-br/sdgs" target="_blank">maiores informações</a>)</small>: </p>
	{#each listaODSCadastrada as ods}
		<p>→ { ods.descricao }</p>
	{:else}
		<p>→ Nenhum ODS cadastrado ou projeto não pode ser relacionado a nenhum ODS.</p>
	{/each}

	<hr>

	{#if anexos?.length > 0}
	<p class="is-size-4 mb-4">Anexos</p>
	
	<div style="overflow-x: auto !important">
		<table class="table is-fullwidth is-hoverable">
			<thead>
				<tr>
					<th>#</th>
					<th>Tipo</th>
					<th>Valor</th>
					<th class="has-text-right" title="Operações disponíveis">Operações</th>
				</tr>
			</thead>
			<tbody>
				{#each anexos as anexo, i}
				<tr>
					<th>{ ++i }</th> 
					<td>{ anexo.tipo }</td>
					{#if (anexo.valor.trim().length > 64)}
					<td>{ anexo.valor_resumo.trim() }...</td>
					{:else}
					<td>{ anexo.valor.trim() }</td>
					{/if}
					<td class="has-text-right">
						<button on:click={ exibirAnexoProjeto(anexo) } class="button is-success is-small">Ler</button>
						<button on:click={() => removerAnexo(anexo.id)} class="button is-danger is-small">Remover</button>
					</td>
				</tr>
				{/each}
			</tbody>
		</table>
	</div>
	{/if}

	{#if participantes?.length > 0}

	<p class="is-size-4 mb-4">Participantes</p>

	<table class="table is-fullwidth is-hoverable">
		<thead>
			<tr>
				<th>#</th>
				<th>Nome</th>
				<th>E-mail</th>
				<th>Unidade</th>
				<th>Papel</th>
				<th>Status</th>
				<th class="has-text-right">Operações</th>
			</tr>
		</thead>
		<tbody>
			{#each participantes as participante, i}
			<tr class="{participante.ativo != true ? 'riscar-linha' : ''}">
				<th>{ ++i }</th> 
				<td><a href="#/usuario/visualizar/{ participante.cpf }">{ participante.nome }</a></td>
				<td>{ participante.email }</td>
				<td>{ participante.unidade }</td>
				<td>{ participante.papel }</td>
				<td>{ participante.ativo ? 'Ativo' : 'Inativo' }</td>
				<td class="has-text-right">
					{#if perfilUsuarioToken == TipoPerfil.CETREINA || perfilUsuarioToken == TipoPerfil.COORDENADOR}
						{#if participante.ativo == true}
							<a href="#/projeto/participantes/ativar-inativar/{projeto.id}/{participante.id}/{window.btoa('INATIVAR')}/{projeto.codigo}" class="button is-danger is-small">Inativar</a>
						{:else}
							<a href="#/projeto/participantes/ativar-inativar/{projeto.id}/{participante.id}/{window.btoa('ATIVAR')}/{projeto.codigo}" class="button is-success is-small">Ativar</a>
						{/if}
					{:else}
						<small>...</small>
					{/if}
				</td>
			</tr>
			{/each}
		</tbody>
	</table>
	{/if}

	{#if perfilUsuarioToken == TipoPerfil.CETREINA}

	<p class="is-size-4 mb-4">Distribuição</p>

	<table class="table is-fullwidth is-hoverable">
		<thead>
			<tr>
				<th>#</th>
				<th>Avaliador(a)</th>
				<th>Data distr.</th>
				<th>Detalhes</th>
				<th class="has-text-right">Data aceite</th>
			</tr>
		</thead>
		<tbody>
			{#each distribuicoes as distribuicao, i}
			<tr>
				<th>{ ++i }</th> 
				<td><a href="#/usuario/visualizar/{ distribuicao.avaliador.cpf }">{ distribuicao.avaliador.nome }</a></td>
				<td>{ distribuicao.data_distribuicao }</td>
				<td><a href="#/distribuicao/desfazer/confirmacao/{ distribuicao.id }" class="button  is-small is-dark is-outlined">Desfazer</a></td>
				<td class="has-text-right">{ distribuicao.data_aceite }</td>
			</tr>
			{:else}
				<tr>
					<td colspan="6">Projeto não distribuído.</td>
				</tr>
			{/each}
		</tbody>
	</table>
	{/if}

	{#if avaliacoes?.length > 0}
	<br>

	{#if perfilUsuarioToken == TipoPerfil.CETREINA}
	<p class="is-size-4 mb-4">Avaliações</p>

	<table class="table is-fullwidth is-hoverable">
		<thead>
			<tr>
				<th>#</th>
				<th>Avaliador(a)</th>
				<th>Pontuação</th>
				<th>Última atualização</th>
				<th>Detalhes</th>
				<th class="has-text-right">Status</th>
			</tr>
		</thead>
		<tbody>
			{#each avaliacoes as avaliacao, i}
			<tr>
				<th>{ ++i }</th> 
				<td><a href="#/usuario/visualizar/{ avaliacao.avaliador.cpf }">{ avaliacao.avaliador.nome }</a></td>
				<td>{ avaliacao.pontuacao }</td>
				<td>{ avaliacao.data_ultima_atualizacao }</td>
				{#if perfilUsuarioToken == TipoPerfil.CETREINA}
				<td><a href="#/avaliacao/visualizar/{avaliacao.id}" class="button  is-small is-dark is-outlined">Abrir</a></td>
				{:else}
				<td>...</td>
				{/if}
				<td class="has-text-right">{ avaliacao.finalizada == true ? 'Finalizada' : 'Pendente' }</td>
			</tr>
			{:else}
			<tr>
				<td colspan="6">Nenhuma avaliação ainda.</td>
			</tr>
			{/each}
		</tbody>
	</table>
	
	{:else}
	
	<h1 class="title is-2 mt-6 mb-6 has-text-centered">Histórico de Avaliações</h1>

	<table class="table is-fullwidth is-bordered">
		<thead>
			<tr>
				<th>Ano</th>
				<th>Status da avaliação</th>
				<th>Pontuação</th>
				<th>Ações</th>
			</tr>
		</thead>
		<tbody>
			{#each avaliacoes as avaliacao}
			<tr>
				<td>{ avaliacao.ano_ultima_atualizacao }</td>
				<td class="has-text-right">{ avaliacao.finalizada == true ? 'Finalizada' : 'Pendente' }</td>
				<td>{ avaliacao.pontuacao }</td>
				<td class="has-text-right"><a href="#/avaliacao/visualizar/anonimizada/{avaliacao.id}" class="button is-fullwidth is-small is-primary">Abrir</a></td>
			</tr>
			{:else}
			<tr>
				<td colspan="6">Nenhuma avaliação ainda.</td>
			</tr>
			{/each}
		</tbody>
	</table>
	{/if}
	{/if}
	
	{#if relatorios?.length > 0}
	<br>
	
	{#if perfilUsuarioToken == TipoPerfil.CETREINA}
	<p class="is-size-3 mb-4 has-text-primary">Relatórios</p>
	{:else}
	<p class="is-size-3 mb-4 has-text-primary">Meus relatórios</p>
	{/if}

	<table class="table is-fullwidth is-hoverable">
		<thead>
			<tr>
				<th>#</th>
				<th>Tipo</th>
				<th>Adicionado em</th>
				<th class="has-text-right">Opções</th>
			</tr>
		</thead>
		<tbody>
			{#each relatorios as relatorio, i}
			<tr>
				<th>{ ++i }</th>
				<td>{ relatorio.tipo }</td>
				<td>{ relatorio.data_criacao }</td>
				<td class="has-text-right">
					<button class="button is-small is-success" on:click={ exibirRelatorioProjeto(relatorio) }>Ler</button>
					<a href={`#/projeto/relatorios/atualizacao/${projeto.codigo}/${projeto.id}/${relatorio.id}?tp=${window.btoa(unescape(encodeURIComponent(projeto.titulo)))}`} class="button is-small is-link">Alterar</a>
				</td>
			</tr>
			{/each}
		</tbody>
	</table>

	{#if perfilUsuarioToken == TipoPerfil.COORDENADOR}
	<div class="box">
		<p><strong>Todos os relatórios do projeto</strong>: </p>
		<br>

		<table class="table is-bordered is-fullwidth">
			<thead>
				<tr>
					<th>Autoria</th>
					<th>Tipo</th>
					<th>Adicionado em</th>
				</tr>
			</thead>
			<tbody>
				{#each lista_resumo_relatorios as resumo_relatorio, i}
				<tr>
					<td>{ resumo_relatorio.autoria }</td>
					<td>{ resumo_relatorio.tipo }</td>
					<td>{ resumo_relatorio.data_criacao }</td>
				</tr>
				{/each}
			</tbody>
		</table>		
	</div>
	{/if}

	{/if}

	<hr>

	<!-- <p class="mb-6">Última solicitação de renovação: <strong>{ projeto.data_ultima_solicitacao_renovacao }</strong></p> -->

	<BarraOperacoesRegistro opcoes={ opcoesOperacoesRodape } />
</TBoxInterno>